import React, { useEffect, useState, useCallback, useRef } from "react";
import Header from "./components/Header";
import Body from "./components/Body";
import Footer from "./components/Footer";
import Menu from "./components/Menu";
import HomePlaceholder from "./components/HomePlaceholder";

export default function Overlay({ 
    setShouldAnimate, 
    setStartExperience,
    data,
    shouldAnimate,
    startExperience,
    setStationVisible,
    stationVisible,
    setModelPosition,
    setCameraCoords,
    setCameraHeight,
    setVideoSrc,
    setIsTransitioning,
    isTransitioning,
    videoSrc,
    videoVisible,
    isModelLoaded,
    popupContent, 
    setPopupContent,
    resetAppState,
    isHomePlaceholderVisible,
    setIsHomePlaceholderVisible
    }) {

    const [isMenuActive, setIsMenuActive] = useState(false);

    const handleHomePlaceholderComplete = useCallback(() => {
        setIsHomePlaceholderVisible(false);
    }, [setIsHomePlaceholderVisible]);

    return (
        <div className="overlay">
            <Header 
                isMenuActive={isMenuActive}
                setIsMenuActive={setIsMenuActive}
                startExperience={startExperience}
                isModelLoaded={isModelLoaded}
                shouldAnimate={shouldAnimate}
            />
            <Menu 
                isMenuActive={isMenuActive} 
                setIsMenuActive={setIsMenuActive}
                data={data}
                setCameraCoords={setCameraCoords}
                setCameraHeight={setCameraHeight}
                setStationVisible={setStationVisible}
                stationVisible={stationVisible}
                setVideoSrc={setVideoSrc}
                popupContent={popupContent} 
                setPopupContent={setPopupContent}
                resetAppState={resetAppState}
            />
            <Body 
                setShouldAnimate={setShouldAnimate} 
                shouldAnimate={shouldAnimate}
                setStartExperience={setStartExperience}
                startExperience={startExperience}
                setStationVisible={setStationVisible}
                stationVisible={stationVisible}
                setModelPosition={setModelPosition}
                data={data}
                setVideoSrc={setVideoSrc}
                setIsTransitioning={setIsTransitioning}
                isTransitioning={isTransitioning}
                videoSrc={videoSrc}
                videoVisible={videoVisible}
            />
            <Footer 
                data={data}
                popupContent={popupContent} 
                setPopupContent={setPopupContent}
            />
            <HomePlaceholder 
                isVisible={isHomePlaceholderVisible}
                onAnimationComplete={handleHomePlaceholderComplete}
            />
        </div>
    )
}